import {StyledSmall, StyledSmallError, StyledSmallSuccess} from '@components/ui/input-help-text/style.ts'

interface InputHelpTextProps {
    error?: string
    success?: string
    helpText?: string
}
export const InputHelpText = ({error, success, helpText}: InputHelpTextProps) => {
    return (
        <>
            {error ? (
                <StyledSmallError>{error}</StyledSmallError>
            ) : success ? (
                <StyledSmallSuccess>{success}</StyledSmallSuccess>
            ) : (
                <StyledSmall>{helpText}</StyledSmall>
            )}
        </>
    )
}

InputHelpText.displayName = 'InputHelpText'
